// extracted by mini-css-extract-plugin
export default {"wrapper":"M_ProfileMobileTabs_wrapper__FwjEq","content":"M_ProfileMobileTabs_content__pDPoZ","tab":"M_ProfileMobileTabs_tab__8BAf6","active":"M_ProfileMobileTabs_active__IiXcc"};